import { apiClient } from '@/utils/api-client'

const API_INTERNAL_BASE = '/profile/favorites'

/**
 * Profile favorite service for project/environment favorites.
 */
class ProfileFavoriteService {
    /**
     * Create a favorite for a project environment.
     *
     * @param {string} projectKey - Project key
     * @param {string} environmentKey - Environment key
     * @returns {Promise<Object>} Create response
     */
    async create(projectKey, environmentKey) {
        return await apiClient
            .post(
                API_INTERNAL_BASE + '/' + projectKey + '/' + environmentKey,
                []
            )
            .then((response) => {
                return response.data
            })
    }

    /**
     * List all favorites for the current user.
     *
     * @returns {Promise<Object>} Favorites list response
     */
    async list() {
        return await apiClient.get(API_INTERNAL_BASE).then((response) => {
            return response.data
        })
    }

    /**
     * Remove a favorite for a project environment.
     *
     * @param {string} projectKey - Project key
     * @param {string} environmentKey - Environment key
     * @returns {Promise<Object>} Remove response
     */
    async remove(projectKey, environmentKey) {
        return await apiClient
            .delete(API_INTERNAL_BASE + '/' + projectKey + '/' + environmentKey)
            .then((response) => {
                return response.data
            })
    }
}

export default new ProfileFavoriteService()
